<div class="container row">
  <app-config-line
    [title]="'Visualización en Vehículos'"
    [titleLevel]="7"
    [withHr]="false"
    [sectionReturn]="configSections.VIEWS_PREFERENCES"
    [render]="!filterOptionsBy"
  >
  </app-config-line>

  <app-config-line
    [title]="'Mapa: Mostrar todos los vehículos'"
    [description]="'Permite habilitar o deshabilitar la visualización de todos los vehículos en el mapa.'"
    [filterBy]="filterOptionsBy"
  >
    <!-- Checkbox para habilitar/deshabilitar -->
    <div class="form-check">
      <input
        class="form-check-input custom-checkbox"
        type="checkbox"
        [pTooltip]="'Activar/Desactivar'"
        [(ngModel)]="vehicleConfigService.configuration.view.showOnMap.enabled"
      >
    </div>

    <!-- Switch -->
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [pTooltip]="'Ocultar/Mostrar'"
        [(ngModel)]="vehicleConfigService.configuration.view.showOnMap.visible"
        (change)="toggleDisplayVisible()"
      />
      <span class="slider"></span>
    </label>  
  </app-config-line>

  <app-config-line
    [title]="'Vista agrupada por operación'"
    [description]="'Organiza y muestra los vehículos agrupados según la operación a la que pertenecen.'"
    [filterBy]="filterOptionsBy"
  >
    <!-- Checkbox para habilitar/deshabilitar -->
    <div class="form-check">
      <input
        class="form-check-input custom-checkbox"
        type="checkbox"
        [pTooltip]="'Activar/Desactivar'"
        [(ngModel)]="vehicleConfigService.configuration.view.showByOperation.enabled"
      >
    </div>

    <!-- Switch -->
    <label class="custom-switch mb-0">
      <input
        [pTooltip]="'Ocultar/Mostrar'"
        type="checkbox"
        [(ngModel)]="vehicleConfigService.configuration.view.showByOperation.visible"
        (change)="toggleDisplayVisible()"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <app-config-line
    [title]="'Mapa: Mostrar solo vehículos visibles'"
    [description]="'Restringe la visualización en el mapa únicamente a los vehículos actualmente visibles.'"
    [filterBy]="filterOptionsBy"
  >
    <!-- Checkbox para habilitar/deshabilitar -->
    <div class="form-check">
      <input
        class="form-check-input custom-checkbox"
        type="checkbox"
        [pTooltip]="'Activar/Desactivar'"
        [(ngModel)]="vehicleConfigService.configuration.view.showOnlyVisible.enabled"
      >
    </div>

    <!-- Switch -->
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [pTooltip]="'Ocultar/Mostrar'"
        [(ngModel)]="vehicleConfigService.configuration.view.showOnlyVisible.visible"
        (change)="toggleDisplayVisible()"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>


  <app-config-line
    [title]="'Resumen de estados de transmisión'"
    [description]="'Muestra en el panel principal un resumen con la cantidad de vehículos en cada estado de transmisión.'"
    [filterBy]="filterOptionsBy"
  >
    <!-- Switch -->
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [pTooltip]="'Ocultar/Mostrar'"
        [(ngModel)]="vehicleConfigService.configuration.panel.showIconsTransmision"
        (change)="toggleShowIcons()"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>



  <app-config-line
    [title]="'Crear grupos, operaciones o convoyes'"
    [description]="'Activa o desactiva el botón para organizar vehículos en grupos, operaciones o convoyes.'"
    [filterBy]="filterOptionsBy"
  >
    <!-- Switch -->
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [pTooltip]="'Ocultar/Mostrar'"
        [(ngModel)]="vehicleConfigService.configuration.panel.btnCreateGroup"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <app-config-line
    [title]="'Personalización de tarjetas de vehículos'"
    [description]="'Habilita la opción para modificar la visualización y diseño de las tarjetas de los vehículos en el panel.'"
    [filterBy]="filterOptionsBy"
  >
    <!-- Switch -->
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [pTooltip]="'Ocultar/Mostrar'"
        [(ngModel)]="vehicleConfigService.configuration.panel.btnCustomPanel"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <ng-container *appHasPermission="'configuration_card_vehicle'">
    <app-config-line
      [title]="'Personalizar tarjeta de vehículo'"
      [titleLevel]="7"
      [filterBy]="filterOptionsBy"
    >
      <div body class="col-12 mb-3">
        <app-user-card-vehicle></app-user-card-vehicle>
      </div>
    </app-config-line>
  </ng-container>
  
</div>
